import { ApiResponse } from "types/api.types";
import { AuthResponse } from "features/Authentication/types/auth.types";
import axiosClient from "utils/axios";

export const signIn = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  try {
    const response = await axiosClient.post<ApiResponse<AuthResponse>>(
      "/auth/login",
      {
        email,
        password,
      },
    );
    return response.data;
  } catch (err) {
    console.warn("Error Signing In : ", err);
    throw err;
  }
};

export const getProfile = async () => {
  try {
    const response =
      await axiosClient.get<ApiResponse<AuthResponse>>("/auth/profile");
    return response.data;
  } catch (err) {
    console.warn("Error fetching profile : ", err);
    throw err;
  }
};

export const getRefreshToken = async () => {
  try {
    const response =
      await axiosClient.get<ApiResponse<AuthResponse>>("/auth/refresh");
    return response.data;
  } catch (err) {
    console.warn("Error fetching refresh token : ", err);
    throw err;
  }
};

/** Public: always same success message (no email enumeration). */
export const forgotPassword = async (body: { email: string }) => {
  const response = await axiosClient.post<ApiResponse<unknown>>(
    "/auth/forgot-password",
    body,
  );
  return response.data;
};

/** Public: `400` if token missing, expired, or invalid. */
export const resetPassword = async (body: {
  token: string;
  newPassword: string;
}) => {
  const response = await axiosClient.post<ApiResponse<unknown>>(
    "/auth/reset-password",
    body,
  );
  return response.data;
};
